import { tooltipTexts } from "constants/tooltip"

type TooltipArgs = {
  id?: string
  projectTooltips?: Record<string, string>
  projectId?: string
}

export const useTooltipContent = ({
  projectTooltips,
  id,
  projectId,
}: TooltipArgs): string | null => {
  if (!id) {
    return null
  }

  if (projectId || projectTooltips) {
    // primarily favor given projectTooltips as they should be more dynamic/prone to updates
    const projectTexts =
      projectTooltips || (projectId ? tooltipTexts[projectId] : projectTooltips)
    if (typeof projectTexts === "object" && projectTexts[id]) {
      return projectTexts[id]
    }
  }
  // still allows cases where id is project specific but gets secondarily found from main level tooltips.
  const text = tooltipTexts[id]

  if (typeof text === "string") {
    return text
  }
  return null
}
